import React from 'react';
import Confirm from './confirm.js'
import Hammer from 'hammerjs';
import axios from 'axios';
import { HC_DownloadFileOnPhonegap } from './phonegapUtils';
import {isFreeVersion} from './helpers';

(function GetSiteLogo() {    
    const isFreeSite = isFreeVersion();
    document.title = isFreeSite ? 'HACCP for Free' : 'HACCP Point';
    window.HC_SITE_LOGO = {
        isFree: isFreeSite,
        src: `public/images/${isFreeSite ? 'logo.svg' : 'logo-point.png'}`,
        style: isFreeSite ? {width: '234px', height: '92px'} : {width: 'auto', height: '192px'}
    };
})();

export default function RegisterGlobalFunctions() {
    if (window.HC_Global)
        return;
    window.HC_Global = true;

    HC_FixPrototypes();
    // HC_RegPushNotifications();

    try {
        window.HC_DEBUG = localStorage.getItem('hc_debug') === '1';
    } catch(err) {
        window.HC_DEBUG = false;
    }

    window.HC_DUE_INTERVAL = 60000;
    window.HC_LongDateTimeOptions = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit',
        hour12: false
    };

    window.HC_ShortDateOptions = {
        year: 'numeric', month: '2-digit', day: '2-digit'
    };

    window.HC_Languages = ['en', 'du', 'ge', 'sp', 'it','tu','ch', 'fr', 'ru'];
    window.HC_CONST = GetConstants();
    SetLocalStorageSupported();

    window.HC_RestoreNavPanel = HC_RestoreNavPanel;
    window.HC_ToggleNavPanel = HC_ToggleNavPanel;
    window.HC_SelectNavItem = HC_SelectNavItem;
    window.HC_SelectItem = HC_SelectItem;
    window.HC_Logout = HC_Logout;

    window.HC_SwitchRPanel = HC_SwitchRPanel;
    window.HC_RestoreRPanel = HC_RestoreRPanel;
    window.HC_DeviceType = HC_DeviceType;
    window.HC_SendRequest = HC_SendRequest;
    window.HC_DownloadFile = HC_DownloadFile;
    window.HC_GetErrorAllowedStr = HC_GetErrorAllowedStr;
    window.HC_GetFillInStr = HC_GetFillInStr;
    window.HC_FormatDateFull = HC_FormatDateFull;
    window.HC_FormatTime = HC_FormatTime;
    window.HC_SetDataAndSelectedItem = HC_SetDataAndSelectedItem;
    window.HC_GetChecklistText = HC_GetChecklistText;
    window.HC_GetItemById = HC_GetItemById;
    window.HC_CurrentItem = HC_CurrentItem;
    window.HC_Confirm = HC_Confirm;
    window.HC_ShowModal = HC_ShowModal;
    window.HC_CloseModal = HC_CloseModal;
    window.HC_AccInput = HC_AccInput;
    window.HC_AccReports = HC_AccReports;
    window.HC_AccAdmin = HC_AccAdmin;
    window.HC_SA = HC_SA;
    window.HC_CheckLoginAndAcc = HC_CheckLoginAndAcc;
    window.HC_ShowMessage = HC_ShowMessage;
    window.HC_RestorePanelsDefaults = HC_RestorePanelsDefaults;
    window.HC_FormatShortDate = HC_FormatShortDate;
    window.HC_IgnoreClickEvent = HC_IgnoreClickEvent;
    window.HC_NeedHideNavPanel = HC_NeedHideNavPanel;
    window.HC_GetDocumentContent = HC_GetDocumentContent;
    window.HC_SetError = HC_SetError;
    window.HC_IsPasswordCorrect = HC_IsPasswordCorrect;
    window.HC_IsEmailCorrect = HC_IsEmailCorrect;
    window.HC_GetErrorsPeriod = HC_GetErrorsPeriod;
    window.HC_GetFillInPeriod = HC_GetFillInPeriod;
    window.HC_GetReportType = HC_GetReportType;
    //window.HC_BugseeLog = HC_BugseeLog;
    window.HC_GoMainPage = HC_GoMainPage;
    window.HC_SubscribeHammerEvent = HC_SubscribeHammerEvent;
    window.HC_UnsubscribeHammerEvent = HC_UnsubscribeHammerEvent;
    window.HC_GetSiteAddr = HC_GetSiteAddr;
    window.HC_GoDefaultPage = HC_GoDefaultPage;
    window.HC_SendDeviceToken = HC_SendDeviceToken;
    window.HC_CheckSubscription = HC_CheckSubscription;
    window.HC_SetLoginSettings = HC_SetLoginSettings;
    window.HC_IsSubscribed = HC_IsSubscribed;

        // settings and coockies
    window.HC_SetSetting = HC_SetSetting;
    window.HC_GetSetting = HC_GetSetting;
    window.HC_GetBoolSetting = HC_GetBoolSetting;
    window.HC_SetCookie = HC_SetCookie;
    window.HC_GetCookie = HC_GetCookie;
    window.HC_GetSession = HC_GetSession;
    window.HC_SetSession = HC_SetSession;
    window.HC_InitReCaptcha = HC_InitReCaptcha;

    //--------- validation -----------------
    window.HC_Validate = HC_Validate;
    window.HC_ValidateNotEmptyField = HC_ValidateNotEmptyField;
    window.HC_ValidateEmail = HC_ValidateEmail;
    window.HC_ValidatePassword = HC_ValidatePassword;
    window.HC_ValidateCaptcha = HC_ValidateCaptcha;
    window.HC_PolarToCartesian = HC_PolarToCartesian;
    window.HC_DescribeArc = HC_DescribeArc;
    window.HC_IsFloat = HC_isFloat;
    window.HC_IsInteger = HC_isInt;
    //--------------------------------------

    DetectBrowsers();

    $(window).resize(HC_RestorePanelsDefaults);
}

function DetectBrowsers() {
    window.HC_IsChrome   = navigator.userAgent.indexOf('Chrome') > -1;
    window.HC_IsExplorer = navigator.userAgent.indexOf('MSIE') > -1;
    window.HC_IsFirefox  = navigator.userAgent.indexOf('Firefox') > -1;
    window.HC_IsSafari   = navigator.userAgent.indexOf("Safari") > -1;
    if ((HC_IsChrome) && (HC_IsSafari)) window.HC_IsSafari = false;
}

function GetConstants() {
    //TODO: maybe chane it all to class with readonly properties, but I'm not sure about performance
    return {
        SCR_DESCKTOP: 0,
        SCR_TABLET: 1,
        SCR_LARGE_PHONE: 2,
        SCR_PHONE: 3,

        CL_MODE_EDIT: 0,
        CL_MODE_CREATE: 1,
        CL_MODE_ORDER: 2,

        MIN_YEAR: 2000,
        MAX_YEAR: 2050,

        SLIDE_DELAY: 150,

        // Report modes
        RM_VIEW: 0, // view report
        RM_CREATE: 1, // create report
        RM_QR: 2, // view QR code
        RM_LINK: 3, // copy link
        RM_VIEW_FULL: 4, // view report via link
        RM_VIEW_NOAUTH: 5, // view report via link not authorized

        REPORT_OVERVIEW: 0,
        REPORT_ERRORS: 1,
        REPORT_NOT_FILLED: 2,
        REPORT_ALL_INPUT: 3,

        CL_TYPE_REGULAR: 0,
        CL_TYPE_TEMP: 1,

    };
}

function HC_IgnoreClickEvent(e) {
    e.stopPropagation(true);
    e.preventDefault(true);
}

function HC_ToggleNavPanel() {
    if (!$('body').hasClass('hc-nav-open'))
        $('body').addClass('hc-nav-open');
}

function HC_NeedHideNavPanel() {
    return !window.HC_GetSession() || window.location.pathname.indexOf("/report/") >=0;
}

function HC_RestoreNavPanel() {
    $('body').removeClass('hc-nav-open');
}

function HC_SelectNavItem(itemId) {
    HC_SelectItem($("#nav-panel * li"), $("#" + itemId));
}

function HC_SelectItem(selectorItems, item, extraClass=null) {
    if (selectorItems) {
        selectorItems.removeClass("hc-active-item");
        if (extraClass)
            selectorItems.removeClass(extraClass);
    }
    if (item) {
        item.addClass("hc-active-item");
        if (extraClass)
            selectorItems.addClass(extraClass);
    }
}

function HC_Logout() {
    HC_SendRequest("logout", {session_id: HC_GetSession()}, HC_GoMainPage);

    HC_SetSession('');
    HC_SetSetting('HC_AccAdmin', '');
    HC_SetSetting('HC_AccReports', '');
    HC_SetSetting('HC_AccInput', '');
    HC_SetSetting('HC_SA', '');
    HC_SetSetting('HC_IsOwner', '');
    HC_SetSetting('HC_IsSubscribed', '');

    // clear token for push notifications
    //data.token = "";
    //HC_SendRequest("send_device_token", data, null, null, false);
}

function HC_GoMainPage(reload=true) {
    if (reload) {
        if (HC_PG)
            window.location = 'index.html';
        else
            window.location = '/';
    } else {
        //TODO
    }
}

function HC_AccAdmin() {
    return HC_GetSetting('HC_AccAdmin') == 1;
}

function HC_AccInput() {
    return HC_GetSetting('HC_AccInput') == 1;
}

function HC_AccReports() {
    return HC_GetSetting('HC_AccReports') == 1;
}

function HC_SA() {
    return HC_GetSetting('HC_SA') == 1;
}

function HC_SwitchRPanel(disableAnimation=false, onComplete=null) {
    if (!$('body').hasClass('hc-rpanel'))
        $('body').addClass('hc-rpanel');
}

function HC_RestoreRPanel(onComplete=null) {
    $('body').removeClass('hc-rpanel');
    $('.hc-content-panel').removeClass('hc-top-most');

}

function HC_DeviceType() {
    var width = $(window).width();
    if(width >= 1200)
        return HC_CONST.SCR_DESCKTOP;
    if(width >= 1024 )
        return HC_CONST.SCR_TABLET;
    if(width >= 736 )
        return HC_CONST.SCR_LARGE_PHONE;
    return HC_CONST.SCR_PHONE;
}

function HC_SendRequest(command, data, success, error= null) {
    var request = {"command": command};
    request["lang"] = window.HC_CURRENT_LANGUAGE;
    if (data) {
        request["data"] = data;
    }
    // add session id
    if (window.cordova) {
        if (!data)
            request["data"] = {};
        request.data['session_id'] = HC_GetSession();
    }

    //var jsonStr = JSON.stringify(request);
    let requestUrl = window.HC_SERVER ? window.HC_SERVER + "/api" : '/api';
    const config = { headers: { 'Content-Type': 'application/json' } };

    axios.post(requestUrl, request, config )
        .then(function (response) {
            var errText = null;
            if (!response.data || !response.data.status) {
                errText = HC_LANG.UT_SERVER_REP_EMPTY;
            } else {
                if (response.data.status != 200) {
                    if (response.data.error_message)
                        errText = response.data.error_message;
                    else
                        errText = HC_LANG.UT_SERVER_REP_STATUS + ": " + response.data.status;
                } else {
                    // SUCCESS!
                    if (success)
                        success(response.data);
                    return;
                }
            }

            if (response && (response.data.status == 400 || response.data.status == 500 )){
                // HC_SetError(response.status, errText);
                // return;
                console.log('error happen', errText);
            }

            if (error)
                error(response.data.status, errText);
            else {
                // no error handler, so we show standard error page
                if (response.data && response.data.status == 401)
                    HC_SetSession('');

                //HC_SetError((response && response.data.status) ? response.data.status : null, errText);
                console.log('error happen', errText);
            }
        })
        .catch(function (status, err) {
            console.error(HC_LANG.UT_FAIL_PROC + ": " + status);
            if (status == 'error') {
                HC_SetError(null, HC_LANG.UT_CONN_REJ);
            } else {
                HC_SetError(status, err);
            }
        });
}

function HC_DownloadFile(path, fileName) {
    var fileUrl = HC_GetSiteAddr() + "download/" + path;
    var sessionId = HC_GetSession();

    // mobile
    if (window.cordova) {
        HC_DownloadFileOnPhonegap(fileUrl, fileName, sessionId);
        return;
    }

    $.ajax({
        url: fileUrl + "?hc_session_id=" + sessionId,
        xhrFields: {
            responseType: 'blob'
        },
        beforeSend: function(request) {
            request.setRequestHeader("hc_session_id", sessionId);
        },
        type: 'GET',
        success: function (data) {
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        },
        error: function(reply) {
            console.log('error downloading', reply.responseText);
        }
    });
}

function  HC_SetError(err_code, err_message){
    $("#nav-panel").css("display", "none");
    $('#react-content').css('width', '100%');
    window.HC_LastError = {code: err_code, message: err_message };
    HC_History.replace("/error");
}

function HC_GetCookie(name) {
    if (window.cordova) {
        return HC_GetSetting(name);
    }
    name += "=";
    var cookies = document.cookie.split(';');
    for (var i=0, il = cookies.length; i < il; ++i) {
        var c = cookies[i];
        while (c.charAt(0)==' ')
            c = c.substring(1);
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}

function HC_SetCookie(name, value, expiresDate=null) {
    if (window.cordova) {
        return HC_SetSetting(name, value);
    }
    var expires = expiresDate ? "; expires="+ d.toUTCString() : "";
    document.cookie = name + '=' + value + expires;
}

function HC_SetSession(token) {
    if (window.cordova)
        return HC_SetSetting('hc_session_id', token);
    return HC_SetCookie('hc_session_id', token);
}

function HC_GetSession() {
    if (window.cordova)
        return HC_GetSetting('hc_session_id');
    return HC_GetCookie('hc_session_id');
}

function HC_GetFillInStr(str) {
    /*every|2|day, every|5|month, every|4|week*/

    //TODO: implement for other languages
    if (!str)
        return '';
    var split = str.split('|');
    var result = HC_LANG.CHL_EVERY + ' ';
    if (split[1] == '2')
        result += HC_LANG.CHL_OTHER;
    else if (split[1] != '1')
        result += split[1];

    if (split[2] == 'ampm') result += ' ' + HC_LANG.CHL_MORN_AFT;
    else if (split[2] == 'd') result += ' ' + HC_LANG.CHL_DAY.toLowerCase();
    else if (split[2] == 'w') result += ' ' + HC_LANG.CHL_WEEK;
    else if (split[2] == 'm') result += ' ' + HC_LANG.CHL_MONTH;

    return result;
}

function HC_GetErrorAllowedStr(str) {
    /*count|XX  XX one of: d, w, m*/
    //TODO: implement for other languages
    var split = str.split('|');
    var result = split[0] + ' ';
    if (split[1] == 'd') result += HC_LANG.CHL_PER_DAY.toLowerCase();
    else if (split[1] == 'w') result += HC_LANG.CHL_PER_WEEK.toLowerCase();
    else if (split[1] == 'm') result += HC_LANG.CHL_PER_MONTH.toLowerCase();
    return result;
}

function HC_GetLocale() {
    return 'uk';
}

function HC_FormatDateFull(date) {
    var date = new Date(date);
    return HC_FormatShortDate(date) + ", " + HC_FormatTime(date);
}

function HC_FormatShortDate(date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1; //January is 0!

    var yyyy = date.getFullYear();
    if(dd<10){
        dd='0'+dd
    }
    if(mm<10){
        mm='0'+mm
    }
    return dd+'.'+mm+'.'+yyyy;
}

function HC_FormatTime(date) {
    var hh = date.getHours();
    var mm = date.getMinutes();

    if(hh<10){
        hh='0'+hh
    }
    if(mm<10){
        mm='0'+mm
    }
    return hh+':'+mm;
}

function HC_SetDataAndSelectedItem(context, data, newState={}) {
    var selectedId = null;
    if (data && context.state.selectedId)
        if ($(data).is(function(i){return data[i].id == context.state.selectedId}))
            selectedId = context.state.selectedId;
    if (!selectedId && data && data.length > 0)
        selectedId = data[0].id;
    newState.data = data;
    newState.selectedId = selectedId;
    newState.noData = false;
    context.setState(newState);
}

function HC_GetChecklistText(o) {
    let i = 0, strings;
    if (o.checklist_type == HC_CONST.CL_TYPE_REGULAR) {
        strings = [
            HC_LANG.DUE_FILL_IN + ": " + (o.manual_state == 0 ? HC_GetFillInStr(o.fill_in) : HC_LANG.CHL_MANUALLY),
            HC_LANG.DUE_ERR_ALLOW + ": " + HC_GetErrorAllowedStr(o.errors_allowed),
            HC_LANG.DUE_LAST_FILLED + ": " + (o.last_filled ? HC_FormatDateFull(o.last_filled) : HC_LANG.DUE_NEVER)
        ];
    }
    else {
        strings = [
            HC_LANG.DUE_FILL_IN + ": " + (o.manual_state == 0 ? HC_GetFillInStr(o.fill_in) : HC_LANG.CHL_MANUALLY),
            HC_LANG.DUE_LAST_FILLED + ": " + (o.last_filled ? HC_FormatDateFull(o.last_filled) : HC_LANG.DUE_NEVER),
            HC_LANG.CHL_DURATION + ": " + (o.duration ? o.duration : "") + " " + HC_LANG.CHL_HOURS
        ];
        if (o.range != o.duration * 60)
            strings.push(HC_LANG.CHL_RANGE + ": " + (o.range ? o.range : "") + " " + HC_LANG.CHL_MINUTES);
        if (o.manual_state == 0)
            strings.push(HC_LANG.CHL_START_TIME + ": " + (o.startup_time ? HC_FormatDateFull(o.startup_time) : ""))
    }

    if (o.by)
        strings.push(HC_LANG.DUE_BY + ": " + o.by);
    if (o.checklist_type == 0 && o.last_results)
        strings.push(HC_LANG.DUE_LAST_RESULT + ": " + o.last_results);
    let items = strings.map(function(s) {return (<div key={i++}>{s}</div>);});
    return <div>{items}</div>;
}

function HC_GetItemById(list, id) {
    if (!list || !id)
        return null;
    for (var i=0; i<list.length; i++)
        if (list[i].id == id)
            return list[i];
    return null;
}

function HC_CurrentItem(context) {
    return HC_GetItemById(context.state.data, context.state.selectedId);
}

function HC_Confirm(message, confirmLabel = HC_LANG.UT_OK, abortLabel = HC_LANG.DUE_CANCEL, style = {
    maxWidth: '25rem',
    width: '90%'
}, ignoreCloseOnConfirm = false) {
    var promise = new $.Deferred();
    var props = {
        message: message,
        confirmLabel: confirmLabel,
        abortLabel: abortLabel,
        'data-style': style,
        promise: promise,
        ignoreCloseOnConfirm: ignoreCloseOnConfirm
    };

    HC_ShowModal(Confirm, props);
    return promise;
};

function HC_ShowMessage(message, btnOk = HC_LANG.UT_OK) {
    var promise = new $.Deferred();
    var props = {
        message: message,
        confirmLabel: btnOk,
        promise: promise
    };

    HC_ShowModal(Confirm, props);
    return promise;
}

function HC_ShowModal(objectClass, properties) {
    if (!properties)
        properties = {};
    window.HC_Modal = React.createElement(objectClass, properties);
    window.HC_UpdateAll();
}

function HC_CloseModal() {
    window.HC_Modal = null;
    window.HC_UpdateAll();
}

function HC_CheckLoginAndAcc(context, func=null) {
    var code = null;
    var error = null;
    if (!HC_GetSession()) {
        code = 401;
        error = HC_LANG.UT_NOT_LOGINED;
    }
    if (!error && func && !func()) {
        code = 403;
        error = HC_LANG.UT_U_NOT_ALLOW;
    }
    if (error) {
        context.render = function () {
            return (<div/>);
        };
        context.componentDidMount = function() {};
        HC_SetError(code, error);
    }
}

function HC_RestorePanelsDefaults() {
    HC_RestoreNavPanel();
}

String.prototype.lpad = function(padString, length) {
    var str = this;
    while (str.length < length)
        str = padString + str;
    return str;
}

function SetLocalStorageSupported()
{
    try
    {
        var testKey = 'hc_test_key', storage = window.localStorage;
        storage.setItem(testKey, '1');
        storage.removeItem(testKey);
        window.HC_HasLocalStorage = true;
    }
    catch (error)
    {
        console.warn(HC_LANG.UT_SESS_STORAGE_NOTAVG + ": " + error);
        window.HC_HasLocalStorage = false;
    }
}

function HC_GetBoolSetting(name) {
    return HC_GetSetting(name) == "1";
}

function HC_GetSetting(name) {
    if (window.HC_HasLocalStorage)
        return localStorage[name];
    else
        return window['HC_SETTING_' + name];
}

function HC_SetSetting(name, value) {
    if (window.HC_HasLocalStorage)
        localStorage[name] = value;
    else
        window['HC_SETTING_' + name] = value
}

function HC_GetDocumentContent(content) {
    if (!content)
        return "";
    if (content.indexOf("$$$HC_HTML_DOC_FORMAT$$$") !== 0)
        return content;
    content = content.replace("$$$HC_HTML_DOC_FORMAT$$$", "");
    content = $.text($.parseHTML(content)).trim();
    return content;
}

function HC_IsEmailCorrect(email) {
    var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailRegex.test(email);
}

function HC_IsPasswordCorrect(password) {
    if (typeof password !== 'string')
        return false;

    // at least one number, one lowercase and one uppercase letter
    // at least six characters that are letters, numbers or the underscore
    var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\w{6,}$/;
    return re.test(password);
}

function HC_Validate(parent=null, reset=false) {
    var result = true;
    var items = parent ? $(parent).find('.hc-validated').addBack('.hc-validated') : $('.hc-validated');
    items.toArray().map(function(o) {
        o = $(o); //TODO: refactor
        var func = o.attr('data-vfunc');
        var r;
        if (!reset){
            r = window[func](o.val());
            result &= r[0];
        }
        var errorTextId = o.attr('data-vtext');
        var captionId = o.attr('data-vcaption');
        if (!reset && !r[0]) {
            if (errorTextId)
                $('#' + errorTextId).css('display', 'block').addClass('hc-f5').css('color', '#d0021b').text(r[1]);
            if (captionId)
                $('#' + captionId).css('color', '#d0021b');
            o.addClass('hc-has-error');
        } else {
            // VALID!
            o.removeClass('hc-has-error');
            if (errorTextId)
                $('#' + errorTextId).css('display', 'none');
            if (captionId)
                $('#' + captionId).css('color', '');
        }
    });
    return result;
}

function HC_ValidateNotEmptyField(s) {
    if (typeof s === 'string' && s.trim().length > 0)
        return [true, ""];
    return [false, HC_LANG.SU_FIELD_DONT_EMPTY];
}

function HC_ValidateEmail(s) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (typeof s === 'string' && re.test(s))
        return [true, ""];
    return [false, HC_LANG.PRO_WRONG_EMAIL];
}

function HC_ValidatePassword(s) {
    var re = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
    if (typeof s === 'string' && re.test(s))
        return [true, ""];
    return [false, HC_LANG.UT_INVALID_PASS];
}

function HC_GetErrorsPeriod(code) {
    if (code === 1)
        return ' ' + HC_LANG.CHL_PER_DAY;
    if (code === 2)
        return ' ' + HC_LANG.CHL_PER_WEEK;
    if (code === 3)
        return ' ' + HC_LANG.CHL_PER_MONTH;
    return ' (unknown period)';
}

function HC_GetFillInPeriod(checklist) {
    var r = HC_LANG.CHL_EVERY + ' ' + checklist.fill_count + ' ';
    if (checklist.fill_period === 0)
        r += HC_LANG.CHL_MORN_AFT;
    else if (checklist.fill_period === 1)
        r += HC_LANG.CHL_DAY.toLowerCase();
    else if (checklist.fill_period === 2)
        r += HC_LANG.CHL_WEEK.toLowerCase();
    else if (checklist.fill_period === 3)
        r += HC_LANG.CHL_MONTH.toLowerCase();
    return r;
}

function HC_GetReportType(reportType) {
    if (reportType === HC_CONST.REPORT_OVERVIEW)
        return HC_LANG.CHL_OVERVIEW;
    if (reportType === HC_CONST.REPORT_ERRORS)
        return HC_LANG.CHL_ALL_ERR;
    if (reportType === HC_CONST.REPORT_NOT_FILLED)
        return HC_LANG.CHL_TIME_FILLIND;
    if (reportType === HC_CONST.REPORT_ALL_INPUT)
        return HC_LANG.CHL_ALL_INPUT;
}

/*function HC_BugseeLog(message) {
    if (window.Bugsee) {
        window.Bugsee.log(message);
    }
}*/

function HC_FixPrototypes() {
    if (!Array.prototype.find) {
        Array.prototype.find = function(predicate) {
            if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }
}

function HC_SubscribeHammerEvent(target, eventName, func) {
    if (HC_DeviceType() !== HC_CONST.SCR_DESCKTOP) {
        if (target != undefined) {
            Hammer(target).on(eventName, function () {
                func();
            });
        }
        //else
          //  console.error('target is UNDEFINED');
    }
}

function HC_UnsubscribeHammerEvent(target, eventName) {
    if (target)
        Hammer(target).off(eventName);
}


function HC_GetSiteAddr() {
    return (window.HC_SERVER ? window.HC_SERVER : window.location.origin) + "/";
}

window.HC_Guid = function () {
    'use strict';
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split( '' );
    var uuid = new Array( 36 );
    var rnd = 0, r;
    return function () {
        for ( var i = 0; i < 36; i ++ ) {
            if ( i === 8 || i === 13 || i === 18 || i === 23 ) {
                uuid[ i ] = '-';
            } else if ( i === 14 ) {
                uuid[ i ] = '4';
            } else {
                if ( rnd <= 0x02 ) rnd = 0x2000000 + ( Math.random() * 0x1000000 ) | 0;
                r = rnd & 0xf;
                rnd = rnd >> 4;
                uuid[ i ] = chars[ ( i === 19 ) ? ( r & 0x3 ) | 0x8 : r ];
            }
        }
        return uuid.join( '' ).toLowerCase();
    };
}();

function HC_GoDefaultPage() {
    var page = '/profile';
    if (HC_IsSubscribed()) {
        if (HC_SA())
            page = '/view_feedback';
        if (HC_AccInput())
            page = '/due';
    }
    HC_History.replace(page);
}

function HC_IsSubscribed() {
    return HC_GetBoolSetting("HC_IsSubscribed");
}

function HC_CheckSubscription() {
    if (HC_IsSubscribed())
        return true;
    if (!HC_GetBoolSetting("HC_IsOwner"))
        HC_Logout();
    window.location = "/subscription";
}

function HC_RegPushNotifications() {
    // use only for phonegap devices
    if (!HC_PG || HC_GetSession())
        return;

    if (PushNotification === undefined) return;

    var app = {
        // Application Constructor
        initialize: function () {
            this.bindEvents();
        },
        // Bind Event Listeners
        //
        // Bind any events that are required on startup. Common events are:
        // 'load', 'deviceready', 'offline', and 'online'.
        bindEvents: function () {
            document.addEventListener('deviceready', this.onDeviceReady, false);
        },
        // deviceready Event Handler
        //
        // The scope of 'this' is the event. In order to call the 'receivedEvent'
        // function, we must explicitly call 'app.receivedEvent(...);'
        onDeviceReady: function () {
            console.log('Received Device Ready Event');
            console.log('calling setup push');
            app.setupPush();
        },
        setupPush: function () {
            console.log('calling push init');
            var push = PushNotification.init({
                "android": {
                    "senderID": "957739599253"
                },
                "ios": {
                    "sound": true,
                    "vibration": true,
                    "badge": true
                },
                "windows": {}
            });
            console.log('after init');

            push.on('registration', function (data) {
                console.log('registration id: ' + data.registrationId);

                // Post registrationId to server as the value has changed
                HC_SetSetting('HC_PushToken', data.registrationId);
                HC_SendDeviceToken();
            });

            push.on('error', function (e) {
                console.log("push error = " + e.message);
            });

            push.on('notification', function (data) {
                //alert('notification');
                //alert(data);
                console.log('notification event');
                HC_GoDefaultPage();
            });
        }
    };
    app.initialize();
}

function HC_SendDeviceToken() {
    if (!HC_PG || !HC_GetSession())
        return;
    var pushToken = HC_GetSetting('HC_PushToken');
    if (!pushToken)
        return;
    var data = {push_token: pushToken};
    var p = window.device.platform.toLowerCase();
    if (p == 'ios')
        data.platform = 0;
    if (p == 'android')
        data.platform = 1;
    HC_SendRequest("send_device_token", data, null);
}

function HC_PolarToCartesian (centerX, centerY, radius, angleInDegrees) {
    var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: centerX + (radius * Math.cos(angleInRadians)),
        y: centerY + (radius * Math.sin(angleInRadians))
    };
}
function HC_DescribeArc (x, y, radius, startAngle, endAngle) {
    var start = HC_PolarToCartesian(x, y, radius, endAngle);
    var end = HC_PolarToCartesian(x, y, radius, startAngle);
    var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
    var d = [
        "M", start.x, start.y,
        "A", radius, radius, 0, arcSweep, 0, end.x, end.y
    ].join(" ");
    return d;
}

function HC_SetLoginSettings(reply) {
    HC_SetSession(reply.data.session_id);
    HC_SetSetting('HC_IsOwner', reply.data.is_owner ? '1' : '0');
    HC_SetSetting('HC_IsSubscribed', reply.data.is_subscribed ? '1' : '0');
    HC_SetSetting('HC_AccAdmin', reply.data.acc_admin ? '1' : '0');
    HC_SetSetting('HC_AccReports',reply.data.acc_reports ? '1' : '0');
    HC_SetSetting('HC_AccInput', reply.data.acc_input ? '1' : '0');
    HC_SetSetting('HC_SA', reply.data.sa ? '1' : '0');
}

function HC_InitReCaptcha(captchaId) {
    $('#hc-recaptcha').remove();
    var lang = {
        en: 'en-GB',
        ge: 'de',
        du: 'nl',
        sp: 'es',
        it: 'it',
        ch: 'zh-CN',
        tu: 'tr',
        fr: 'fr'
    };
    $('body').append('<script id="hc-recaptcha" src="https://www.google.com/recaptcha/api.js?hl=' + lang[HC_CURRENT_LANGUAGE] + '" async defer></script>');
}


function HC_ValidateCaptcha() {
    var ok = grecaptcha && grecaptcha.getResponse() != "";
    return [ok, ''];
}

function HC_isInt(n){
    return Number(n) === n && n % 1 === 0;
}

function HC_isFloat(n){
    return Number(n) === n && n % 1 !== 0;
}


// WEBPACK FOOTER //
// ./utils.js